import { createRoute, Outlet, redirect } from "@tanstack/solid-router";
import { isAdminCapable } from "@listto/shared";
import { appRoute } from "./route";
import { sessionActor } from "@/lib/session-machine";
import { readAccountsStateSync } from "@/lib/accounts";
import { resolveActiveAccountView } from "@/lib/active-account";
import { readTabAccountId } from "@/lib/tab-account";

export const adminRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/admin",
  beforeLoad: () => {
    // Per-tab gating: resolve THIS tab's active account (its `sessionStorage`
    // pin → registry), NOT the global session machine. The global machine holds
    // only the last-authed real user, so gating on it would let a GUEST tab into
    // /admin whenever any real admin is signed in elsewhere.
    const view = resolveActiveAccountView(
      readAccountsStateSync(),
      readTabAccountId(),
      sessionActor.getSnapshot().context.session,
    );

    // Back-office (#18): allow any admin-capable role (super_admin/admin/support/
    // read_only). The backend re-checks every action by capability; the per-page
    // UI hides/disables actions a role can't perform. A plain `user` / guest is
    // bounced.
    if (!isAdminCapable(view.role)) {
      // oxlint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: "/profile" });
    }
  },
  component: () => <Outlet />,
});
